import React, { useState } from 'react';
import { Button, Card, CardBody, CardTitle, Col, Container, Row, Table } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
import tamga from '../../../assets/images/tamga.png'
import * as html2pdf from 'html2pdf.js';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const ReportBox2_1 = () => {

  const [h23Value, setH23Value] = useState('');
  const [h24Value, setH24Value] = useState('');
  const [h30Value, setH30Value] = useState('');

  const [i24Value, setI24Value] = useState('');
  const [i25Value, setI25Value] = useState('');
  const [i26Value, setI26Value] = useState('');
  const [i27Value, setI27Value] = useState('');
  const [i28Value, setI28Value] = useState('');
  const [i29Value, setI29Value] = useState('');
  const [i31Value, setI31Value] = useState('');
  const [i32Value, setI32Value] = useState('');
  const [i33Value, setI33Value] = useState('');

  const [j24Value, setJ24Value] = useState('');
  const [j27Value, setJ27Value] = useState('');

  const [k24Value, setK24Value] = useState('');
  const [k25Value, setK25Value] = useState('');
  const [k26Value, setK26Value] = useState('');
  const [k27Value, setK27Value] = useState('');
  const [k28Value, setK28Value] = useState('');
  const [k29Value, setK29Value] = useState('');
  
  const [l24Value, setL24Value] = useState('');
  const [l25Value, setL25Value] = useState('');
  const [l26Value, setL26Value] = useState('');
  const [l27Value, setL27Value] = useState('');
  const [l28Value, setL28Value] = useState('');
  const [l29Value, setL29Value] = useState('');

  const [m24Value, setM24Value] = useState('');

  const handleFileRead = async () => {
    const response = await fetch('/report/Report_BOX_2_1.xlsx');
    const arrayBuffer = await response.arrayBuffer();

    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(arrayBuffer);

    const worksheet = workbook.getWorksheet(1);

    console.log(worksheet);
    
    if (worksheet) {
      worksheet.getCell('H23').value = h23Value;
      worksheet.getCell('H24').value = h24Value;
      worksheet.getCell('H30').value = h30Value;

      worksheet.getCell('I24').value = i24Value;
      worksheet.getCell('I25').value = i25Value;
      worksheet.getCell('I26').value = i26Value;
      worksheet.getCell('I27').value = i27Value;
      worksheet.getCell('I28').value = i28Value;
      worksheet.getCell('I29').value = i29Value;
      worksheet.getCell('I31').value = i31Value;
      worksheet.getCell('I32').value = i32Value;
      worksheet.getCell('I33').value = i33Value;

      worksheet.getCell('J24').value = j24Value;
      worksheet.getCell('J27').value = j27Value;

      worksheet.getCell('K24').value = k24Value;
      worksheet.getCell('K25').value = k25Value;
      worksheet.getCell('K26').value = k26Value;
      worksheet.getCell('K27').value = k27Value;
      worksheet.getCell('K28').value = k28Value;
      worksheet.getCell('K29').value = k29Value;

      worksheet.getCell('L24').value = l24Value;
      worksheet.getCell('L25').value = l25Value;
      worksheet.getCell('L26').value = l26Value;
      worksheet.getCell('L27').value = l27Value;
      worksheet.getCell('L28').value = l28Value;
      worksheet.getCell('L29').value = l29Value;

      worksheet.getCell('M24').value = m24Value;
      
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, 'Report_BOX_2_1.xlsx');
    } else {
      console.error('Worksheet not found');
    }
  };


  const exportToPDF = () => {
    const element = document.getElementById('exportable-content');

    if (element) {
      const opt = {
        margin: 0.5,
        filename: 'Бох-2_1-тайлан.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, },
        jsPDF: { unit: 'cm', format: 'a4', orientation: 'p' }
      };

      // html2pdf ашиглан PDF болгон хувиргана
      html2pdf().from(element).set(opt).save();
    } else {
      console.error('Element not found!');
    }
  };

  document.title = "БОХ-2.1 маягт. Усны нөөц хомсдол, хамгааллын 20... жилийн мэдээ ";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Тайлан" breadcrumbItem="БОХ-2.1 маягт" />
          <div className="d-flex flex-column mx-auto reportBox" style={{ width: '800px' }}>
            <Card>
              <CardBody className="border-bottom">
                <div id="exportable-content">
                  <Row>
                    <div className="d-flex align-content-between ">
                      <img className="tamga" src={tamga} alt="" />
                      <Col lg={6}>
                        <p style={{ textAlign: 'justify', width: '350px', fontSize: '10px' }}>
                          Үндэсний статистикийн хорооны даргын 2019 оын А/134 дүгээр тушаалаар зөвшөөрснөөр, Байгаль орчин, аялал жуулчлалын сайдын 2019 оны 09 сарын 19 - ны өдрийн А/527 дугаар тушаалаар батлав.
                        </p>
                      </Col>
                      <Col lg={6}>
                        <p style={{ textAlign: 'right', fontSize: '10px' }}>З-БОХ-2.1</p>
                      </Col>
                    </div>
                  </Row>
                  <Row>
                    <CardTitle className="text-center text-uppercase" style={{ fontSize: '12px' }}> усны нөөц, хомсдол, хамгааллын 2024 оны жилийн мэдээ </CardTitle>
                  </Row>
                  <Row>
                    <CardTitle className=" text-uppercase" style={{ fontSize: '12px' }}> 1. Хаягийн хэсэг </CardTitle>
                  </Row>
                  <Row>
                    <Col lg={5}>
                      <div>
                        <table className="table table-bordered border-dark tableTopLeftCenter">
                          <thead>
                            <tr>
                              <th style={{ width: '200px', padding: '0' }}> Байршил </th>
                              <th style={{ width: '250px', padding: '0' }}> Нэр </th>
                              <th style={{ width: '100px', padding: '0' }}> Код </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={{ padding: '0' }}>Аймаг, нийслэл</td>
                              <td style={{ padding: '0' }}>  </td>
                              <td style={{ padding: '0' }}>  </td>
                            </tr>
                            <tr>
                              <td style={{ padding: '0' }}> Сум, дүүрэг </td>
                              <td style={{ padding: '0' }}>  </td>
                              <td style={{ padding: '0' }}>  </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Col>

                    <Col lg={7}>
                      <p style={{ textAlign: 'justify', fontSize: '10px' }} className="p-0 m-0">
                        1. Сум, дүүргийн байгаль орчны асуудал хариуцсан мэргэжилтэн нь мэдээг дараа оны 2 дугаар сарын 01-ны дотор аймаг, нийслэлийн байгаль орчны асуудал эрхэлсэн газарт цахимаар болон маягтаар ирүүлнэ.
                      </p>
                      <p style={{ textAlign: 'justify', fontSize: '10px' }} className="p-0 m-0">
                        2. Аймаг, нийслэлийн байгаль орчны асуудал эрхэлсэн газар нь мэдээг хянаж, нэгтгээд 2 дугаар сарын 15-ны дотор Байгаль орчны мэдээллийн төвд цахим хэлбэрээр ирүүлнэ.
                      </p>
                      <p style={{ textAlign: 'justify', fontSize: '10px' }} className="p-0 m-0">
                        3. Байгаль орчны мэдээллийн төв нь мэдээг хянаад 2 дугаар сарын 25-ны дотор байгаль орчны асуудал эрхэлсэн төрийн захиргааны төв байгууллагын усны асуудал хариуцсан нэгжид цахим хэлбэрэр ирүүлнэ.
                      </p>
                      <p style={{ textAlign: 'justify', fontSize: '10px' }} className="p-0 m-0">
                        4. Байгаль орчны асуудал эрхэлсэн төрийн захиргааны төв байгууллагын усны асуудал хариуцсан нэгж нь мэдээг хянаж, нэгтгээд 3 дугаар сарын 10-ны дотор статистик хариуцсан нэгжид цахимаар болон маягтаар ирүүлнэ.
                      </p>
                      <p style={{ textAlign: 'justify', fontSize: '10px' }} className="p-0 m-0">
                        5. Байгаль орчны асуудал эрхэлсэн төрийн захиргааны төв байгууллагын статистик хариуцсан нэгж нь мэдээг хянаж 3 дугаар сарын 20-ны дотор Үндэсний статистикийн хороонд цахимаар болон маягтаар ирүүлнэ.
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <CardTitle className=" text-uppercase" style={{ fontSize: '12px' }}> 2. Үндсэн үзүүлэлт </CardTitle>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive">
                        <table className="table table-bordered border-dark tableTopLeftCenter">
                          <thead>
                            <tr style={{ borderBottom: 'unset' }}>
                              <th rowSpan={2} colSpan={8}>Үзүүлэлт</th>
                              <th rowSpan={2}>МД</th>
                              <th rowSpan={2}>Нөөцийн хэмжээ, мян.м3 </th>
                              <th rowSpan={2}>Усны эх үүсвэрийн тоо</th>
                              <th colSpan={3}></th>
                              <th rowSpan={2}>Тусгай хамгаалалт авсан усны урсац бүрэлдэх эх газрын талбай, мян.га</th>
                            </tr>

                            <tr style={{ borderTop: 'unset' }}>
                              <th >Хашиж, хамгаалалт авсан</th>
                              <th >Сэргэсэн</th>
                              <th >Хатаж ширгэсэн</th>
                            </tr>

                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan={8} className="fw-semibold ">A</td>
                              <td >Б</td>
                              <td >1</td>
                              <td >2</td>
                              <td >3</td>
                              <td >4</td>
                              <td >5</td>
                              <td >6</td>
                            </tr>
                            <tr>
                              <td colSpan={8} className="fw-semibold" style={{ textAlign: 'left' }}>Нийт мөр1=мөр(2+9)</td>
                              <td> 1 </td>
                              <td>       
                                <input
                                className='reportBoxField'
                                type="text"
                                value={h23Value}
                                onChange={(e) => setH23Value(e.target.value)}
                                placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td> X </td>
                              <td> X </td>
                              <td> X </td>
                              <td> X </td>
                              <td> X </td>
                            </tr>
                            <tr>
                              <td rowSpan={11} ></td>
                              <td colSpan={7} className="fw-semibold" style={{ textAlign: 'left' }}>Гадаргын ус мөр2=мөр(3:8)</td>
                              <td>2</td>
                              <td>                          
                                <input
                                className='reportBoxField'
                                type="text"
                                value={h24Value}
                                onChange={(e) => setH24Value(e.target.value)}
                                placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>                          
                                <input
                                className='reportBoxField'
                                type="text"
                                value={i24Value}
                                onChange={(e) => setI24Value(e.target.value)}
                                placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>       
                                <input
                                className='reportBoxField'
                                type="text"
                                value={j24Value}
                                onChange={(e) => setJ24Value(e.target.value)}
                                placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>       
                                <input
                                className='reportBoxField'
                                type="text"
                                value={k24Value}
                                onChange={(e) => setK24Value(e.target.value)}
                                placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>       
                                <input
                                className='reportBoxField'
                                type="text"
                                value={l24Value}
                                onChange={(e) => setL24Value(e.target.value)}
                                placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>       
                                <input
                                className='reportBoxField'
                                type="text"
                                value={m24Value}
                                onChange={(e) => setM24Value(e.target.value)}
                                placeholder="Утга оруулах . . ."/> 
                              </td>
                            </tr>
                            <tr >
                              <td rowSpan={6} ></td>
                            </tr>
                            <tr>
                              <td colSpan={6} style={{ textAlign: 'left' }}>Гол мөрөн</td>
                              <td>3</td>
                              <td>X</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i25Value}
                                  onChange={(e) => setI25Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>X</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k25Value}
                                  onChange={(e) => setK25Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l25Value}
                                  onChange={(e) => setL25Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>X</td>
                            </tr>
                            <tr>
                              <td colSpan={6} style={{ textAlign: 'left' }}>Нуур тойром</td>
                              <td>4</td>
                              <td>X</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i26Value}
                                  onChange={(e) => setI26Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>X</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k26Value}
                                  onChange={(e) => setK26Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l26Value}
                                  onChange={(e) => setL26Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>X</td>
                            </tr>
                            <tr>
                              <td colSpan={6} style={{ textAlign: 'left' }}>Булаг шанд</td>
                              <td>5</td>
                              <td>X</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i27Value}
                                  onChange={(e) => setI27Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={j27Value}
                                  onChange={(e) => setJ27Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k27Value}
                                  onChange={(e) => setK27Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l27Value}
                                  onChange={(e) => setL27Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>X</td>
                            </tr>
                            <tr>
                              <td colSpan={6} style={{ textAlign: 'left' }}>Рашаан</td>
                              <td>6</td>
                              <td>X</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i28Value}
                                  onChange={(e) => setI28Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>X</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k28Value}
                                  onChange={(e) => setK28Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l28Value}
                                  onChange={(e) => setL28Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>X</td>
                            </tr>
                            <tr>
                              <td colSpan={6} style={{ textAlign: 'left' }}>Усан сан (Хөв цөөрөм)</td>
                              <td>7</td>
                              <td>X</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i29Value}
                                  onChange={(e) => setI29Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>X</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k29Value}
                                  onChange={(e) => setK29Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l29Value}
                                  onChange={(e) => setL29Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>X</td>
                            </tr>
                            <tr>
                              <td colSpan={7} className="fw-semibold" style={{ textAlign: 'left' }}>Газрын доорх ус</td>
                              <td>8 </td>
                              <td>                          
                                <input
                                className='reportBoxField'
                                type="text"
                                value={h30Value}
                                onChange={(e) => setH30Value(e.target.value)}
                                placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>X</td>
                              <td>X</td>
                              <td>X</td>
                              <td>X</td>
                              <td>X</td>
                            </tr>
                            <tr>
                              <td rowSpan={3}></td>
                              <td style={{ textAlign: 'left' }} colSpan={6}>Худаг мөр9 &#62;&#61; мөр10 </td>
                              <td>9</td>
                              <td>X</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i31Value}
                                  onChange={(e) => setI31Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>X</td>
                              <td>X</td>
                              <td>X</td>
                              <td>X</td>
                            </tr>
                            <tr>
                              <td rowSpan={2}></td>
                              <td colSpan={5} style={{ textAlign: 'left' }}>Инженерийн хийцтэй худаг</td>
                              <td>10</td>
                              <td>X</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i32Value}
                                  onChange={(e) => setI32Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>X</td>
                              <td>X</td>
                              <td>X</td>
                              <td>X</td>
                            </tr>
                            <tr>
                              <td colSpan={5} style={{ textAlign: 'left' }}> Энгийн уурхайн худаг</td>
                              <td>11</td>
                              <td>X</td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={i33Value}
                                  onChange={(e) => setI33Value(e.target.value)}
                                  placeholder="Утга оруулах . . ."/> 
                              </td>
                              <td>X</td>
                              <td>X</td>
                              <td>X</td>
                              <td>X</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                    </Col>
                  </Row>
                </div>
                <Row>
                  <Col className="d-flex justify-content-evenly">
                    <button onClick={exportToPDF}
                      type="button"
                      className="btn btn-primary  btn-label"
                    >
                      <i className="mdi mdi-download label-icon"></i>{" "}
                      PDF Татах
                    </button>

                    <button onClick={handleFileRead}
                      type="button"
                      className="btn btn-success  btn-label"
                    >
                      <i className="mdi mdi-download label-icon"></i>{" "}
                      Excel Татах
                    </button>

                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>

        </Container>
      </div>
    </React.Fragment >
  );
}

export default ReportBox2_1;